import { Query, Relation } from "@nozbe/watermelondb";
import {
  children,
  field,
  date,
  immutableRelation,
  text,
  writer,
} from "@nozbe/watermelondb/decorators";
import { Associations } from "@nozbe/watermelondb/Model";
import { InventoryMovementItemStatus } from "@towersystems/roam-common/lib/generated-types";
import { BaseModel } from "./Base";
import InventoryMovement from "./InventoryMovement";
import Product from "./Product";
import Count from "./Count";

export default class InventoryMovementItem extends BaseModel {
  static table = "inventory_movement_items";

  static associations: Associations = {
    inventory_movement: { type: "belongs_to", key: "inventory_movement_id" },
    counts: {
      type: "has_many",
      foreignKey: "inventory_movement_item_id",
    },
  };

  @immutableRelation("inventory_movements", "inventory_movement_id")
  inventoryMovement: Relation<InventoryMovement>;
  @immutableRelation("products", "product_id") product: Relation<Product>;

  @text("stock_code") stockCode: string | null;
  @text("status") status: InventoryMovementItemStatus | null;

  @field("counted") counted: number | null;
  @field("initial_expected") initialExpected: number | null;
  @field("expected") expected: number | null;
  @field("cost") cost: number;
  @field("manual") manual: boolean;

  @writer async triggerUpdate() {
    await this.update();
  }

  // local only
  @children("counts")
  counts: Query<Count>;
}
